
import { useParams } from "react-router-dom";

import { DisenioPaginas } from "../../layout";
import { CargandoMedio, FormCreateUpdateGalpon } from "../../components";
import { useGalponXID } from "../../../hooks";







export const ActualizarGalpon = () => {


    const { id } = useParams();
    const { galponXIDQuery } = useGalponXID(`${id}`);
    const galpon = galponXIDQuery?.data


    const initialState = (galpon) ? {
        nombre: galpon.nombre || '',
        cantidad: galpon.cantidad || '',
        genero: galpon.genero || '',
        granja: galpon.granja || '',
        alto: galpon.alto || '',
        largo: galpon.largo || '',
        ancho: galpon.ancho || '',
        id: galpon.id || "",
    } : {};

    

    return (

        <DisenioPaginas titulo="Actualizar Galpon" url={1} add={false} subtitulo="Información del galpon">
            {(galponXIDQuery.isLoading)
            ?   <CargandoMedio titulo="Cargando Galpon..." />
            :   <FormCreateUpdateGalpon initialState={initialState} />
            }
        </DisenioPaginas>

    )

}
